import { DATASETS_PAGE_TITLE } from '@/constants/pageTitlesAndDescriptionConstants';
import DatasetIcon from '@/icons/DatasetIcon';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function DatasetsCrumb(props: Partial<BreadcrumbData>) {
  return (
    <Breadcrumb
      icon={props.condensed ? <DatasetIcon /> : undefined}
      name={props.condensed ? '' : DATASETS_PAGE_TITLE}
      {...props}
    />
  );
}
